import { getCLS, getFCP, getFID, getLCP } from 'web-vitals';

import Ga from './ga';

function GAReportHandler({ name, delta, id }) {
    Ga.send({
        eventCategory: 'Web Vitals',
        eventAction: name,
        eventValue: Math.round(name === 'CLS' ? delta * 1000 : delta),
        eventLabel: id,
        nonInteraction: true,
        transport: 'beacon',
    });
}

export function reportWebVitals() {
    getCLS(GAReportHandler);
    getFID(GAReportHandler);
    getLCP(GAReportHandler);
    getFCP(GAReportHandler);
}
